<template>
  <div class="wapper">
    <!-- 开启顶部安全区适配 -->
    <div safe-area-inset-top />
    <router-view v-slot="{ Component }">
      <!-- 走缓存 -->
      <keep-alive>
        <component v-if="$route.meta.keepAlive" :is="Component" />
      </keep-alive>
      <!-- 不走缓存 -->
      <component v-if="!$route.meta.keepAlive" :is="Component" />
    </router-view>
    <!-- 开启底部安全区适配 -->
    <div safe-area-inset-bottom />
  </div>
</template>
<style lang="less">
/* 定制主题 */
:root {
  --van-primary-color: #c03e3e !important;
  --van-button-border-radius: 8px !important;
  --theme-font-color: #333333;
  --theme-vice-font-color: #999999;
  --theme-yellow-color: #e79445;
}
// APP 默认背景色
.wapper {
  background: #f5f5f6;
  min-height: 100vh;
}
</style>
